module.exports = __webpack_public_path__ + "img/s6.f0d7ffc5.png";